import { Tooltip } from 'components/Tooltip/Tooltip'
import { TooltipProps } from 'components/Tooltip/Types'
import { forwardRef, PropsWithChildren, ReactNode } from 'react'
import Styles from './FloatingPopover.module.scss'

interface Props extends Omit<TooltipProps, 'label'> {
  content: ReactNode
}
export const FloatingPopover = forwardRef<HTMLDivElement, PropsWithChildren<Props>>(
  ({ children, content, ...props }, fRef) => {
    return (
      <Tooltip className={Styles.wrapper} label={content} {...props} ref={fRef}>
        {children}
      </Tooltip>
    )
  },
)
